import axios from 'axios';

// - - SAVE_SETTINGS ACTIONS

export const SAVE_SETTINGS = 'SAVE_SETTINGS';
export const SAVE_SETTINGS_SUCCESS = 'SAVE_SETTINGS_SUCCESS';
export const SAVE_SETTINGS_ERROR = 'SAVE_SETTINGS_ERROR';

const requestSaveSettings = (username, email) => {
	return {
		type: SAVE_SETTINGS,
		username,
		email
	};
};

const recieveSaveSettingsSuccess = (username, email) => {
	return {
		type: SAVE_SETTINGS_SUCCESS,
		username,
		email
	};
};

const recieveSaveSettingsError = error => {
	return {
		type: SAVE_SETTINGS_ERROR,
		error
	};
};

export const saveSettings = (username, email) => {
	return async function(dispatch) {
		//
		dispatch(requestSaveSettings(username, email));

		try {
			let response = await axios.get('test.json');
			if (response.status === 200) {
				const { username, email } = response.data.data;
				dispatch(recieveSaveSettingsSuccess(username, email));
			} else {
				dispatch(recieveSaveSettingsError());
			}
		} catch (error) {
			dispatch(recieveSaveSettingsError(error));
		}
	};
};
